module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Jonen_AG-4f22e372a1555967f3152d9be47d9e64.svg";